
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';

/**
 * BalanceCurrencyListResponse struct
 */
class BalanceCurrencyListResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Array=} currencies
   * @param {!string=} defaultCurrency
   * @constructor
   */
  constructor (parent = new Response(), currencies = [], defaultCurrency = '') {
    super()
    super.copy(parent)
    this.Currencies = currencies
    this.DefaultCurrency = defaultCurrency
  }

  /**
   * Copy struct (shallow copy)
   * @this {!BalanceCurrencyListResponse}
   * @param {!BalanceCurrencyListResponse} other Other struct
   * @returns {!BalanceCurrencyListResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Currencies != null) {
      this.Currencies = []
      for (let item of other.Currencies) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.Currencies.push(tempItem)
        } else {
          this.Currencies.push(null)
        }
      }
    } else {
      this.Currencies = null
    }
    if (other.DefaultCurrency != null) {
      this.DefaultCurrency = other.DefaultCurrency
    } else {
      this.DefaultCurrency = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!BalanceCurrencyListResponse}
   * @returns {!BalanceCurrencyListResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new BalanceCurrencyListResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new BalanceCurrencyListResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!BalanceCurrencyListResponse}
   * @param {!BalanceCurrencyListResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof BalanceCurrencyListResponse)) {
      throw new TypeError('Instance of BalanceCurrencyListResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!BalanceCurrencyListResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Currencies: ((this.Currencies != null) ? Array.from(this.Currencies, item => ((item != null) ? item : null)) : null),
      DefaultCurrency: ((this.DefaultCurrency != null) ? this.DefaultCurrency : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return BalanceCurrencyListResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!BalanceCurrencyListResponse} other Object value
   * @returns {!BalanceCurrencyListResponse} Created struct
   */
  static fromObject (other) {
    return new BalanceCurrencyListResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!BalanceCurrencyListResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return BalanceCurrencyListResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!BalanceCurrencyListResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 7002
  }
}

export { BalanceCurrencyListResponse };

/**
 * Fast Binary Encoding BalanceCurrencyListResponse field model
 */
class FieldModelBalanceCurrencyListResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.Currencies = new fbe.FieldModelVector(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.DefaultCurrency = new fbe.FieldModelString(buffer, this.Currencies.fbeOffset + this.Currencies.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Currencies.fbeSize + this.DefaultCurrency.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Currencies.fbeExtra + this.DefaultCurrency.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelBalanceCurrencyListResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 7002
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Currencies.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Currencies.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Currencies.fbeSize

    if ((fbeCurrentSize + this.DefaultCurrency.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.DefaultCurrency.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultCurrency.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @param {!BalanceCurrencyListResponse} fbeValue Default value, defaults is new BalanceCurrencyListResponse()
   * @returns {!BalanceCurrencyListResponse} BalanceCurrencyListResponse value
   */
  get (fbeValue = new BalanceCurrencyListResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @param {!BalanceCurrencyListResponse} fbeValue BalanceCurrencyListResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Currencies.fbeSize) <= fbeStructSize) {
      this.Currencies.get(fbeValue.Currencies)
    } else {
      fbeValue.Currencies.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Currencies.fbeSize

    if ((fbeCurrentSize + this.DefaultCurrency.fbeSize) <= fbeStructSize) {
      fbeValue.DefaultCurrency = this.DefaultCurrency.get()
    } else {
      fbeValue.DefaultCurrency = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.DefaultCurrency.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @param {!BalanceCurrencyListResponse} fbeValue BalanceCurrencyListResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelBalanceCurrencyListResponse}
   * @param {BalanceCurrencyListResponse} fbeValue BalanceCurrencyListResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Currencies.set(fbeValue.Currencies)
    this.DefaultCurrency.set(fbeValue.DefaultCurrency)
  }
}

export { FieldModelBalanceCurrencyListResponse };

/**
 * Fast Binary Encoding BalanceCurrencyListResponse model
 */
class BalanceCurrencyListResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelBalanceCurrencyListResponse(this.buffer, 4)
  }

  /**
   * Get the BalanceCurrencyListResponse model
   * @this {!BalanceCurrencyListResponseModel}
   * @returns {!FieldModelBalanceCurrencyListResponse} model BalanceCurrencyListResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!BalanceCurrencyListResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!BalanceCurrencyListResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return BalanceCurrencyListResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!BalanceCurrencyListResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelBalanceCurrencyListResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!BalanceCurrencyListResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!BalanceCurrencyListResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!BalanceCurrencyListResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!BalanceCurrencyListResponseModel}
   * @param {!BalanceCurrencyListResponse} value BalanceCurrencyListResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!BalanceCurrencyListResponseModel}
   * @param {!BalanceCurrencyListResponse} value BalanceCurrencyListResponse value, defaults is new BalanceCurrencyListResponse()
   * @return {!object} Deserialized BalanceCurrencyListResponse value and its size
   */
  deserialize (value = new BalanceCurrencyListResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new BalanceCurrencyListResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new BalanceCurrencyListResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!BalanceCurrencyListResponseModel}
   * @param {!number} prev Previous BalanceCurrencyListResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { BalanceCurrencyListResponseModel };
